import { useQuery } from '@tanstack/react-query';

import { getSharesAvailableForAccount } from '@arrived/api_v2';
import { OfferingId, TotalAvailableSharesResponse } from '@arrived/models';

import { UseQueryOptions } from '../queries.utils';
import { useGetPrimaryAccountQuery } from '../users';
import { accountSharesAvailableKeyFn } from './sharesAvailable.keys';

export function useSharesAvailableForAccountQuery(
  offeringId?: OfferingId,
  options?: UseQueryOptions<TotalAvailableSharesResponse>
) {
  const { data } = useGetPrimaryAccountQuery();
  const accountId = data?.id;

  return useQuery(
    accountSharesAvailableKeyFn(offeringId!, accountId!),
    async () => getSharesAvailableForAccount(accountId!, offeringId!),
    {
      ...options,
      staleTime: options?.staleTime ?? 10_000,
      enabled: (options?.enabled ?? true) && offeringId != null && accountId != null,
    }
  );
}
